import http from '../common/http'
//查询代修中心订单明细
export const GetNavigation = param => (
  http.get('/Trouble/GetNavigation', param)
)

export const GetRepairItem = param => (
  http.get('/AgentRepair/GetRepairItem', param)
)

export const GetStoreList = () => (
  http.get('/store/GetStoreList')
)

export const getAgentrepairOrderDetail = param => (
  http.post('/AgentRepair/OrderDetail', param)
)

export const GetRepairCenterListByUser = () => (
  http.get('/AgentRepair/GetUserContextRepairCenterList')
)


export const GetRepairCenterList = param => (
  http.get('/AgentRepair/GetRepairCenterList', { repairtype: param })
)

export const CreateOrder = param => (
  http.post('/AgentRepair/CreateOrder', param)
)

//取消订单
export const CancelOrder = param => (
  http.post('/AgentRepair/CancelOrder',  param)
)
//维修师放弃订单
export const GiveUpOrder = param => (
  http.post('/AgentRepair/GiveUpOrder',  param)
)
//获取多条快递信息
export const GetExpressInfo = param => (
  http.post('/AgentRepair/GainExpressInfo', param)
)

//订单发货（填写快递单号）
export const AddExpressNumber = param => (

  http.post('/AgentRepair/AddExpressNumber', param)
)
//更新快递信息
export const UpdateExpressInfo = param => (
  http.post('/AgentRepair/UpdateExpressInfo', param)
)

//作废订单
export const DiscardOrder = param => (
  http.post('/AgentRepair/DiscardOrder', param)
)

//接单维修
export const RepairOrder = param => (
  http.post('/AgentRepair/RepairOrder', param)
)

//维修完成
export const RepairCompleted = param => (
  http.post('/AgentRepair/RepairCompleted', param)
)
//更新维修师备注
export const UpdateRepairRemark = param => (
  http.post('/AgentRepair/UpdateRepairRemark', param)
)

  //收款完成
  export const ServiceOrderPay = param => (
    http.post('/AgentRepair/ServiceOrderPay',param)
  )

  //配件编码查询
export const GetOneCode = code => (
	http.get('/AgentRepair/GetOneCode', { code: code })
)



// WEBPACK FOOTER //
// ./src/api/agentRepairApi.js